import { createAlignmentExtension } from "./custom/alignment";
import { createFileExtension } from "./custom/file";
import { createMentionExtension } from "./custom/mention";
import { createVideoExtension } from "./custom/video";
import defaultExtensions from "./default";

const customExtensions = {
  mention: createMentionExtension,
  file: createFileExtension,
  video: createVideoExtension,
  alignment: createAlignmentExtension,
} as const;

type DefaultExtensionName = keyof typeof defaultExtensions;
type CustomExtensionName = keyof typeof customExtensions;

const createExtension = (
  name: string,
  options: Array<Record<string, unknown>> = [],
) => {
  if (!name) {
    throw new Error('Extension requires "name" property.');
  }

  if (name in defaultExtensions) {
    const usedOption = options[options.length - 1];
    return defaultExtensions[name as DefaultExtensionName](usedOption);
  }

  if (name in customExtensions) {
    return customExtensions[name as CustomExtensionName](options);
  }

  throw new Error(`Extension with "${name}" does not exist.`);
};

export default createExtension;
